import React, { useContext, useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router';
import ConfigContext from '../../../contexts/ConfigContext';
import { useGetBlogPostsQuery } from '../../../redux/slices/blogPostSlice';
import usePagination from '../../../hooks/usePagination';

// Components
import Hero from '../content/Hero';
import QuoteCta from '../content/QuoteCta';
import Meta from '../../shared/Meta';
import BlogPostTease from './BlogPostTease';
import BlogSidebar from './BlogSidebar';
import CateringCta from '../content/CateringCta';
import Paginate from '../../shared/Paginate';

// Styles
import paginateRoundTheme from '../../shared/Paginate-round.module.postcss';
import sidebarStyles from '../../../../stylesheets/public/layouts/SidebarLayout.module.postcss';
import styles from './BlogCategory.module.postcss';

function BlogSearchResults() {
  const { base_url } = useContext(ConfigContext);
  const location = useLocation();

  const [query, setQuery] = useState('');

  // Get search query from URL
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const newQuery = params.get('q') || '';
    setQuery(newQuery);
  }, [location.search]);

  const [page, setPage] = useState(1);

  const { data = {} } = useGetBlogPostsQuery({
    published: true,
    page_size: 6,
    page,
    search: query
  });
  const blogPosts = data.blog_posts || [];
  const pagination = data.pagination;

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const newPage = urlParams.get('page') || 1;
    setPage(newPage);
  }, [location.search]);

  const { paginationProps, showPagination } = usePagination({
    pagination,
    options: { theme: paginateRoundTheme, previousLabel: '<', nextLabel: '>' }
  });

  const structuredData = {
    breadcrumbs: { listItems: [
        {
          '@type': 'ListItem',
          position: 2,
          name: 'Blog',
          item: base_url + '/blog',
        },
        {
          '@type': 'ListItem',
          position: 3,
          name: 'Blog Search',
          item: base_url + '/blog-search',
        },
      ] },
  };

  return (
    <div>
      <Meta
        title='Blog Search'
        type='website'
        structuredData={structuredData}
      />

      <Hero photo='https://static.seattlefoodtruck.com/photos/home-hero.webp' />

      <div className='Section Section--extraPadding u-pb0'>
        <h1 className='u-mb0'>Blog Search</h1>
      </div>

      <div className='Section Section--extraPadding'>
        <div className={sidebarStyles.SidebarLayout}>
          <div className={sidebarStyles.SidebarLayout_body}>

            <div className='InnerSection'>
              { query &&
                <>
                  <h2 className='u-mb1'>{query}</h2>
                  <hr className='u-mb2' />
                </>
              }
              <QuoteCta />
            </div>

            <div className='InnerSection'>
              <div className={styles.BlogGrid}>
                { blogPosts.map((blogPost) => {
                  return (
                    <BlogPostTease blogPost={blogPost} key={blogPost.id} />
                  );
                })}
                { blogPosts.length === 0 &&
                  <p>No blog posts found matching your search.</p>
                }
              </div>
              { showPagination && <Paginate {...paginationProps} /> }
            </div>

            <div className='InnerSection u-mb0'>
              <CateringCta />
            </div>

          </div>
          <div className={sidebarStyles.SidebarLayout_sidebar}>
            <BlogSidebar />
          </div>
        </div>
      </div>
    </div>
  );
}

export default BlogSearchResults;
